import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { motion } from "framer-motion";
import OtpInput from "react-otp-input";

import { authContext } from "../../../context/AuthContext/AuthContext";

import { logo } from "../../../assets";
import { signUpUserValidation } from "../../../utils/validation/validation";

import ValidationErrorMessage from "../../../helpers/ValidationErrorMessage/ValidationErrorMessage";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";

import { HiEye, HiEyeOff } from "react-icons/hi";
import { MdInstallDesktop, MdInstallMobile } from "react-icons/md";

const SignUp = ({ changeFormPage, setChangeFormPage }) => {
  const {
    isShowPassSignUp,
    setIsShowPassSignUp,
    isShowPassSignUpConfirm,
    setIsShowPassSignUpConfirm,
    signUpCode,
    setSignUpCode,
    isChange,
    isShowForm,
    handleSignUp,
    handleOtpSignUp,
    setDeferredPrompt,
    showInstallButton,
    setShowInstallButton,
    handleInstallClick,
  } = useContext(authContext);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  // Validation
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(signUpUserValidation),
  });

  const [isAcceptRule, setIsAcceptRule] = useState(false);
  const [isShowAcceptRule, setIsShowAcceptRule] = useState(false);

  return (
    <>
      <SiteTitle title="ثبت نام کاربر" />
      <motion.div
        initial={{ opacity: 0, rotateY: 180 }}
        animate={{
          opacity: 1,
          rotateY: 0,
          transition: {
            duration: 1,
          },
        }}
        className="2xl:w-3/12 xl:w-4/12 lg:w-5/12 md:w-6/12 sm:w-7/12 w-10/12 
        py-5 flex flex-col bg-boxColor rounded-2xl"
      >
        <div className="flex items-center w-full px-6 mx-auto">
          <div className="flex-1">
            {/* Logo */}
            <div className="flex justify-center items-center mb-8">
              <img
                src={logo}
                alt="Website Logo"
                className="rounded-full bg-cover w-28 h-28"
              />
            </div>
            {/* Title */}
            <div className="text-center flex justify-center">
              {isChange ? (
                <h2 className="text-2xl font-bold text-center cursor-pointer text-white">
                  کد تأیید برای ثبت نام
                </h2>
              ) : (
                <>
                  <h2
                    onClick={() => setChangeFormPage("signin")}
                    className="text-2xl font-bold text-center cursor-pointer
              hover:text-gray-300 text-white"
                  >
                    ورود
                  </h2>
                  <span className="text-2xl font-bold text-center mx-3 text-white">
                    -
                  </span>
                  <h2
                    onClick={() => setChangeFormPage("signup")}
                    className={`text-2xl font-bold text-center cursor-pointer
              hover:text-gray-300 ${
                changeFormPage === "signup" ? "text-green-500" : "text-white"
              }`}
                  >
                    ثبت نام
                  </h2>
                </>
              )}
            </div>
            {/* Form */}
            {isShowForm && (
              <>
                <div className="none mt-5 w-full">
                  <form
                    onSubmit={handleSubmit(handleOtpSignUp)}
                    className="space-y-5"
                  >
                    <span className="space-y-1">
                      {/* First Name / Last Name */}
                      <span className="flex">
                        {/* First Name */}
                        <div className="mx-1">
                          <label
                            htmlFor="firstname"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            نام
                          </label>
                          <input
                            type="text"
                            name="firstname"
                            placeholder="نام"
                            autoComplete="off"
                            {...register("firstname")}
                            className=" block w-full px-4 py-2 mt-2 border rounded-md
                                placeholder-gray-600 bg-zinc-900 text-gray-400 
                                border-zinc-900 focus:border-gray-200 mb-2
                                focus:outline-none focus:text-gray-200 font-medium"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errors.firstname?.message}
                            />
                          </span>
                        </div>
                        {/* Last Name */}
                        <div className="mx-1">
                          <label
                            htmlFor="lastname"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            نام خانوادگی
                          </label>
                          <input
                            type="text"
                            name="lastname"
                            placeholder="نام خانوادگی"
                            autoComplete="off"
                            {...register("lastname")}
                            className=" block w-full px-4 py-2 mt-2 border rounded-md
                                placeholder-gray-600 bg-zinc-900 text-gray-400 
                                border-zinc-900 focus:border-gray-200 mb-2
                                focus:outline-none focus:text-gray-200 font-medium"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errors.lastname?.message}
                            />
                          </span>
                        </div>
                      </span>
                      {/* Phone Number / National Number */}
                      <span className="flex">
                        {/* National Number */}
                        <div className="mx-1">
                          <label
                            htmlFor="nationalid"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            کد ملی
                          </label>
                          <input
                            type="text"
                            name="nationalid"
                            placeholder="کد ملی"
                            autoComplete="off"
                            {...register("nationalid")}
                            className=" block w-full px-4 py-2 mt-2 border rounded-md
                                placeholder-gray-600 bg-zinc-900 text-gray-400 
                                border-zinc-900 focus:border-gray-200 mb-2
                                focus:outline-none focus:text-gray-200 font-medium"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errors.nationalid?.message}
                            />
                          </span>
                        </div>
                        {/* Phone Number */}
                        <div className="mx-1">
                          <label
                            htmlFor="phonenumber"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            شماره موبایل
                          </label>
                          <input
                            type="number"
                            name="phonenumber"
                            placeholder="شماره موبایل"
                            autoComplete="off"
                            {...register("phonenumber")}
                            className=" block w-full px-4 py-2 mt-2 border rounded-md
                                placeholder-gray-600 bg-zinc-900 text-gray-400 
                                border-zinc-900 focus:border-gray-200 mb-2
                                focus:outline-none focus:text-gray-200 font-medium"
                          />
                          <span>
                            <ValidationErrorMessage
                              message={errors.phonenumber?.message}
                            />
                          </span>
                        </div>
                      </span>
                      {/* Gender */}
                      <span>
                        <label
                          htmlFor="gender"
                          className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                        >
                          جنسیت
                        </label>
                        <select
                          defaultValue=""
                          name="gender"
                          {...register("gender")}
                          className="block w-full px-4 py-2 mt-2 border rounded-md
                                placeholder-gray-600 bg-zinc-900 text-gray-400 
                                border-zinc-900 focus:border-gray-200 mb-2
                                focus:outline-none focus:text-gray-200 font-medium"
                        >
                          <option
                            className="text-gray-200"
                            selected
                            hidden
                            value=""
                          >
                            جنسیت
                          </option>
                          <option
                            className="text-gray-200"
                            selected={watch("gender") === 0}
                            value={0}
                          >
                            جنسیت
                          </option>
                          <option
                            className="text-gray-200"
                            selected={watch("gender") === 1}
                            value={1}
                          >
                            مرد
                          </option>
                          <option
                            className="text-gray-200"
                            selected={watch("gender") === 2}
                            value={2}
                          >
                            زن
                          </option>
                        </select>
                        <span>
                          <ValidationErrorMessage
                            message={errors.gender?.message}
                          />
                        </span>
                      </span>
                      {/* Password - Confirm Password */}
                      <span className="flex">
                        {/* Password */}
                        <div className="relative mx-1">
                          <label
                            htmlFor="password"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            رمز عبور
                          </label>
                          <input
                            type={isShowPassSignUp ? "text" : "password"}
                            name="password"
                            placeholder="******"
                            autoComplete="off"
                            {...register("password")}
                            className=" block w-full px-4 py-2 mt-2 border rounded-md
                                placeholder-gray-600 bg-zinc-900 text-gray-400 
                                border-zinc-900 focus:border-gray-200 mb-2
                                focus:outline-none focus:text-gray-200 font-medium"
                          />
                          {/* Show/Hide Password Icon */}
                          <span className="absolute left-2 top-10">
                            {isShowPassSignUp ? (
                              <HiEye
                                onClick={() =>
                                  setIsShowPassSignUp(!isShowPassSignUp)
                                }
                                fill="#fff"
                                className="cursor-pointer"
                              />
                            ) : (
                              <HiEyeOff
                                onClick={() =>
                                  setIsShowPassSignUp(!isShowPassSignUp)
                                }
                                fill="#fff"
                                className="cursor-pointer"
                              />
                            )}
                          </span>
                          <span>
                            <ValidationErrorMessage
                              message={errors.password?.message}
                            />
                          </span>
                        </div>
                        {/* Confirm Password */}
                        <div className="relative mx-1">
                          <label
                            htmlFor="confirmpassword"
                            className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                          >
                            تکرار رمز عبور
                          </label>
                          <input
                            type={isShowPassSignUpConfirm ? "text" : "password"}
                            name="confirmpassword"
                            placeholder="******"
                            autoComplete="off"
                            {...register("confirmpassword")}
                            className=" block w-full px-4 py-2 mt-2 border rounded-md
                                placeholder-gray-600 bg-zinc-900 text-gray-400 
                                border-zinc-900 focus:border-gray-200 mb-2
                                focus:outline-none focus:text-gray-200 font-medium"
                          />
                          {/* Show/Hide Password Icon */}
                          <span className="absolute left-2 top-10">
                            {isShowPassSignUpConfirm ? (
                              <HiEye
                                onClick={() =>
                                  setIsShowPassSignUpConfirm(
                                    !isShowPassSignUpConfirm
                                  )
                                }
                                fill="#fff"
                                className="cursor-pointer"
                              />
                            ) : (
                              <HiEyeOff
                                onClick={() =>
                                  setIsShowPassSignUpConfirm(
                                    !isShowPassSignUpConfirm
                                  )
                                }
                                fill="#fff"
                                className="cursor-pointer"
                              />
                            )}
                          </span>
                          <span>
                            <ValidationErrorMessage
                              message={errors.confirmpassword?.message}
                            />
                          </span>
                        </div>
                      </span>
                      {/* Accept Rules */}
                      <span className="relative flex items-center mr-1">
                        <input
                          type="checkbox"
                          name="acceptRules"
                          onClick={() => setIsAcceptRule(!isAcceptRule)}
                          className="block appearance-none w-4 h-4 bg-white
                        checked:bg-green-600 cursor-pointer rounded-full"
                        />
                        <label
                          htmlFor="acceptRules"
                          className="block mr-2 text-sm font-medium text-gray-200"
                        >
                          ورود شما به معنای{" "}
                          <span
                            onClick={() => {
                              setIsShowAcceptRule(true);
                            }}
                            className="text-green-500 mx-1 tracking-wide hover:underline hover:cursor-pointer"
                          >
                            پذیرش قوانین
                          </span>{" "}
                          سامانه می باشد
                        </label>
                      </span>
                    </span>
                    {/* Button */}
                    <div>
                      {isAcceptRule && (
                        <button
                          type="submit"
                          className={`${
                            isAcceptRule
                              ? "bg-green-500 hover:bg-green-600"
                              : "bg-transparent"
                          }
                          w-full px-4 py-2 tracking-wide text-white font-medium
                          transition-colors duration-200 transform rounded-md 
                          focus:outline-none`}
                        >
                          ثبت نام
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </>
            )}
            {/* Verify Code */}
            {isChange && (
              <>
                <span className="w-full">
                  <form onSubmit={handleSubmit(handleSignUp)}>
                    <div>
                      <label
                        htmlFor="verifyCode"
                        className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                      >
                        کد تأیید
                      </label>
                      <span
                        className="flex justify-center items-center"
                        style={{ direction: "ltr" }}
                      >
                        <OtpInput
                          value={signUpCode}
                          onChange={setSignUpCode}
                          numInputs={5}
                          renderSeparator={<span>-</span>}
                          renderInput={(props) => (
                            <input
                              {...props}
                              type="number"
                              name="verifyCode"
                              autoComplete="off"
                              className="block w-full px5 py-2 my-4 mx-3 border rounded-md
                              placeholder-gray-600 bg-zinc-900 text-gray-400 text-center
                              border-gray-700 focus:border-gray-400 tracking-widest 
                                focus:outline-none focus:text-gray-200 font-medium"
                              style={{ direction: "rtl" }}
                            />
                          )}
                        />
                      </span>
                    </div>
                    {/* Button */}
                    <div>
                      <button
                        type="submit"
                        className="w-full px-4 py-2 tracking-wide text-white font-medium
                    transition-colors duration-200 transform rounded-md mt-5
                  bg-green-500 hover:bg-green-600 focus:outline-none"
                      >
                        تأیید ثبت نام
                      </button>
                    </div>
                  </form>
                  <p className="text-center mt-2 text-gray-200">
                    زمان باقی مانده
                    <span id="verificationCodeCountDown" className="mx-2">
                      120
                    </span>
                    ثانیه
                  </p>
                </span>
              </>
            )}
            {/* Pwa Button */}
            {isShowForm && !isChange && (
              <div className="w-full py-4 text-sm font-medium text-center text-gray-400">
                {showInstallButton && (
                  <button
                    className="w-full py-3 tracking-wide text-white font-medium
            transition-colors duration-200 transform rounded-md 
            flex justify-center text-base
            bg-yellow-500 hover:bg-yellow-400focus:outline-none"
                    onClick={handleInstallClick}
                  >
                    <MdInstallDesktop
                      size={22}
                      className="lg:flex hidden mx-1"
                    />
                    <MdInstallMobile
                      size={22}
                      className="flex lg:hidden mx-1"
                    />
                    نسخه تحت وب
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
        {/* Rules Modal */}
        {isShowAcceptRule && (
          <>
            <div
              className={`absolute flex justify-center items-center h-screen
                  ${
                    isShowAcceptRule
                      ? "animate__animated animate__fadeIn animate__fast"
                      : "animate__animated animate__fadeOut animate__fast"
                  }`}
            >
              <div className="fixed inset-0 px-2 z-10 overflow-hidden flex items-center justify-center">
                <div className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"></div>
                <div
                  className="bg-boxColor text-slate-200 leading-relaxed text-justify rounded-md
                        shadow-xl overflow-hidden w-full lg:w-8/12 md:w-10/12 z-50"
                >
                  <div className="bg-boxColor text-slate-50 p-4 flex justify-between">
                    <h2 className="text-lg font-semibold">قوانین سایت</h2>
                  </div>
                  {/* Rules */}
                  <div className="p-4 w-full h-96 overflow-y-scroll tracking-normal space-y-2">
                    <p>
                      سامانه مصطفی داودی تابع قوانین جمهوری اسلامی ایران بوده و
                      بستری برای معامله فلزات گرانبهایی از قبیل طلا آبشده و تمام
                      سکه و نیم سکه و ربع سکه با ریال می‌باشد. هیچ گونه تبادل
                      ارزی اعم از خرید و فروش دلار یا سایر ارزهای کاغذی، در این
                      بستر صورت نمی گیرد.
                    </p>
                    <p>
                      تعهدنامه فعالیت در سامانه مصطفی داودی کاربران موظفند قبل
                      از ثبت‌نام تمامی مفاد این تعهدنامه را مطالعه نموده و صرفا
                      در صورت پذیرش آن اقدام به ثبت نام نمایند.
                    </p>
                    <p>
                      1-کاربران سایت می‌پذیرند که کلیه‌ی فعالیت‌های آن‌ها در
                      سامانه مصطفی داودی در چارچوب قوانین جمهوری اسلامی بوده و
                      هیچ گونه فعالیتی خارج از این چارچوب انجام نخواهند داد.
                    </p>
                    <p>
                      2-احراز هویت برای استفاده از خدمات سامانه مصطفی داودی
                      ضروری بوده و کاربران موظفند اطلاعات صحیح خود را بارگذاری
                      نمایند. بدیهی است در صورت وجود هرگونه تخلف در احراز هویت،
                      مسئولیت به عهده‌ی فرد متخلف بوده و سامانه مصطفی داودی حق
                      توقف ارائه خدمات به کاربر مذبور و ارجاع موارد تخلف به
                      مراجع ذی صلاح را خواهد داشت. سامانه مصطفی داودی خود را
                      ملزم به حفظ اطلاعات شخصی کاربران خود می‌داند.
                    </p>
                    <p>
                      3-کاربران سامانه مصطفی داودی تعهد می دهند که از خدمات
                      سامانه مصطفی داودی تنها برای خود استفاده نموده و مسئولیت
                      استفاده از خدمات سامانه مصطفی داودی برای فرد غیر به عهده
                      کاربر خواهد بود.
                    </p>
                    <p>
                      4-هرگونه سهل انگاری کاربران در حفظ اطلاعات امنیتی از جمله
                      رمز عبور کاربر، به عهده‌ی شخص کاربر بوده و سامانه مصطفی
                      داودی هیچ مسئولیتی به عهده نخواهد داشت. اکیداً توصیه می
                      شود از رمز عبور پیچیده و امن استفاده شود.
                    </p>
                    <p>
                      5-کاربر می‌پذیرد که به جز در موارد مورد تعهد سامانه مصطفی
                      داودی، حق هیچ گونه داعیه، طلب و شکایت از سایت سامانه مصطفی
                      داودی، مدیران، کارمندان و افراد مرتبط با این سایت را
                      نخواهد داشت.
                    </p>
                    <p>
                      6-در صورت بروز هرگونه مشکل یا ابهام در هر یک از معاملات،
                      سامانه مصطفی داودی حق دارد مستقلاً آن معامله را ابطال و
                      دارایی‌های هر یک از طرفین را به حساب خودشان عودت دهد.
                      بدیهی است که در صورتی که اشکال از سمت سامانه مصطفی داودی
                      باشد، موظف خواهد بود که جبران خسارت نماید و در غیر این
                      صورت کاربر حق هرگونه اعتراض و ادعایی را در خصوص نحوه
                      عملکرد سامانه مصطفی داودی از هر جهت از خود ساقط می‌نماید.
                    </p>
                    <p>
                      7-هرگونه تغییر در قوانین، شروط ارائه خدمات و مقررات مشابه،
                      از طریق سایت سامانه مصطفی داودی به کاربران اطلاع‌رسانی
                      خواهد شد.
                    </p>
                    <p>8-در سامانه مصطفی داودی تمامی معاملات نقدی می‌باشد.</p>
                    <p>9-هیچ یک از معاملات از سمت کاربر برگشت و کنسلی ندارد.</p>
                    <p>
                      10-هر گونه اختلاف حساب بعد از یک روز به عهده خود کاربران
                      می‌باشد.
                    </p>
                    <p>
                      11-تمامی فیش های برگشتی به حساب مشتری شما به عهده خود
                      کاربر می‌باشد.
                    </p>
                  </div>
                  <div className="px-4 py-2 flex justify-end bg-boxColor">
                    <button
                      onClick={() => setIsShowAcceptRule(false)}
                      className="px-3 py-1 bg-red-500 hover:bg-red-600
                          text-white rounded-md w-full sm:w-auto"
                    >
                      بستن
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </motion.div>
    </>
  );
};

export default SignUp;
